import { Injectable } from '@angular/core';
import { APP_BUILD_VERSION } from '../core/config/app-metadata';
import { AuthStorageService } from './auth-storage.service';
import { DeviceDescriptor } from './auth.models';

@Injectable({ providedIn: 'root' })
export class DeviceMetadataService {
  constructor(private readonly authStorage: AuthStorageService) {}

  buildDescriptor(): DeviceDescriptor {
    const browser = this.detectBrowser();
    const os = this.detectOs();

    return {
      deviceName: `${browser.name} ${browser.version} on ${os}`,
      deviceUUID: this.authStorage.readOrCreateDeviceUuid(),
      appVersion: `${browser.name} ${browser.version}`,
      platformVersion: APP_BUILD_VERSION
    };
  }

  private detectBrowser(): { name: string; version: string } {
    const userAgent = navigator.userAgent;
    const browserMatchers: Array<{ pattern: RegExp; name: string }> = [
      { pattern: /Edg\/([\d.]+)/, name: 'Edge' },
      { pattern: /Chrome\/([\d.]+)/, name: 'Chrome' },
      { pattern: /Firefox\/([\d.]+)/, name: 'Firefox' },
      { pattern: /Version\/([\d.]+).*Safari/, name: 'Safari' }
    ];

    for (const matcher of browserMatchers) {
      const match = userAgent.match(matcher.pattern);

      if (match) {
        return {
          name: matcher.name,
          version: match[1]
        };
      }
    }

    return {
      name: 'Browser',
      version: navigator.appVersion || 'unknown'
    };
  }

  private detectOs(): string {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform || '';

    if (/Windows/i.test(platform) || /Windows/i.test(userAgent)) {
      return 'Windows';
    }

    if (/Mac/i.test(platform) || /Mac OS X/i.test(userAgent)) {
      return 'macOS';
    }

    if (/Linux/i.test(platform) || /Linux/i.test(userAgent)) {
      return 'Linux';
    }

    if (/Android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return 'iOS';
    }

    return 'Unknown OS';
  }
}
